/**
 * Footer HTML template – ESM version for Vite/browser (Footer.tsx).
 * Same content as footerTemplate.cjs for Node/static build (renderComponentsToHTML.js).
 * Class names: footer-design, so one CSS (Footer.css) styles both.
 */

const twitterIcon =
  '<svg width="20" height="20" viewBox="0 0 24 24" fill="#ffffff" aria-hidden="true" role="img"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>';
const linkedInIcon =
  '<svg width="20" height="20" viewBox="0 0 24 24" fill="#ffffff" aria-hidden="true" role="img"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>';
const arrowIcon =
  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

/**
 * @param {{
 *   websiteBase?: string;
 *   portalLoginUrl?: string;
 *   logoSrc?: string;
 *   deleteAccountHref?: string;
 * }} options
 * @returns {string} Footer inner HTML (wrap in <footer class="footer-design">)
 */
function getFooterHtml(options = {}) {
  const websiteBase = options.websiteBase || 'https://www.zivohealth.ai';
  const portalLoginUrl = options.portalLoginUrl || 'https://doctor.zivohealth.ai/login';
  const logoSrc = options.logoSrc || 'images/zivo_logo.png';
  const deleteAccountHref = options.deleteAccountHref != null ? options.deleteAccountHref : 'delete-account.html';

  return `<div class="footer-inner">
<div class="footer-content">
<div class="footer-section footer-company">
<a href="${websiteBase}" class="footer-logo-link"><img src="${logoSrc}" alt="ZivoHealth" class="footer-logo-img" /></a>
<p class="footer-tagline">Redefining healthcare through the lens of precision nutrition and metabolic science.</p>
<div class="footer-social">
<a href="https://twitter.com/zivohealth" target="_blank" rel="noopener noreferrer" class="footer-social-icon" aria-label="Twitter">${twitterIcon}</a>
<a href="https://www.linkedin.com/company/zivohealth" target="_blank" rel="noopener noreferrer" class="footer-social-icon" aria-label="LinkedIn">${linkedInIcon}</a>
</div>
<p class="footer-registered-company">Registered company: Dhanvantari AI Labs Private Limited</p>
</div>
<div class="footer-section footer-platform">
<h3 class="footer-heading">PLATFORM</h3>
<ul>
<li><a href="${portalLoginUrl}">For Doctors</a></li>
</ul>
</div>
<div class="footer-section footer-newsletter">
<h3 class="footer-heading">STAY UPDATED</h3>
<p class="footer-newsletter-desc">Join our newsletter for the latest in metabolic research.</p>
<form class="footer-newsletter-form" action="#" method="post" aria-label="Newsletter signup">
<input type="email" name="email" placeholder="Email address" required class="footer-newsletter-input" />
<button type="submit" class="footer-newsletter-btn" aria-label="Subscribe">${arrowIcon}</button>
</form>
</div>
</div>
<div class="footer-bottom">
<p>&copy; 2026 ZivoHealth. All rights reserved.</p>
<ul>
<li><a href="https://www.zivohealth.ai/privacy-policy.html">Privacy Policy</a></li>
<li><a href="https://www.zivohealth.ai/terms-and-conditions.html">Terms and Conditions</a></li>
<li><a href="${deleteAccountHref}">Delete Account</a></li>
</ul>
</div>
</div>`;
}

export default { getFooterHtml };
